import UIkit from './theme/UIkit';
import initAccessibilityAttributes from './theme/accessibilityAttributes';
import initFacebookShare from './theme/facebookShare';
import initHeroVideo from './theme/heroVideo';
import initLoadVenues from './theme/loadVenues';
import initMenuIcon from './theme/menuIcon';
import initScrollspy from './theme/scrollspy';
import initVenueFilter from './theme/venueFilter';

initAccessibilityAttributes();
initFacebookShare();
initHeroVideo();
initLoadVenues();
initMenuIcon();
initScrollspy();
initVenueFilter();